export default __webpack_public_path__ + "static/media/button-mini-filter.fb9d568c.svg";